import { ITag, ITagData } from '../item-tag.types';
import { Tag } from '../item-tag';

export const mockItemTagsData = (): ITagData[] => [
  {
    id: 1,
    name: 'Tag 1'
  },
  {
    id: 2,
    name: 'Tag 2'
  }
];

export const mockItemTags = (data: ITagData[] = mockItemTagsData()): ITag[] =>
  data.map(item => new Tag(item));
